var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    fill: "url(#pattern0_2062_282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2062_282",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2062_282",
    transform: "matrix(0.00787402 0 0 0.00803471 0 -0.00618673)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2062_282",
    width: 127,
    height: 126,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAAB+CAMAAAA6Pz6EAAAAM1BMVEVMaXH020n020n020n020n020n020n020n020n020n020n020n020n020n020n020n020nU+9SqAAAAEHRSTlMAYFAwwCAQ8KDgkHBAsIDQtUYSmgAAAAlwSFlzAAALEgAACxIB0t1+/AAAAr9JREFUaIHNm23bgiAMhUNFfJf//2ufUilUrJA93p2PddVR2M7G2G63JGRZ2u9TUVUsvzEofW5tTvI31jYk/2htDdJre4fm+NsHf8vxFw/+AqMv7YSS4lczv6L4q5m/p/jNzE9JYGYXQDGocfyQBNaOn5HA3D6BxKD2xT8Q/OOLfwTotfUAxCDl8wMS2Pv8gATaFS6PQdma/3IJrNb8l6fhZs1/dQzK7QYXS2Cz5b84Bo1b/mtjkN7S/5cEtl344z1/OA3vErPzzhahJyj2/KE0PC9s+Pm/x52p2i1tuacPSKCuBA4Hk6Ntn0CF+DcxSE8Klfr6TuiGcv/ZBqsYVA6TQAnI4mLqxn8CE+L3JHBhl3EK97LmacpZiN6LQco9n0hU0M+3rZct3onfjEUC1TMvFtKE4UVRT+9YB8jtIoGd96VQWlr6232Xg13scchvnS8MRiopGVYsRdD6H+jXsiSWlZdBe/8Esdc/0JtPkKzLHFjcO4gG5BMLIHskiF4A4Xyki+WXTsgDEf8dxItykQuQHne3iFoA+Zpkfqh6IfSyx4Gsibf/RsgCS1Wdkt+7APcqVYJ1G2n3WxTt+Rwgb3annDOomzPGkJ1d9RBMlcXshFb95/+MRa++24m8FVn1EMbh006ccLQ4vHHL844Wh6BbJjtaHNZuKeRocXBuKepocZjckuan1/8H7O8H/O8H9Mc5I6m/izGQ8cftBBh/3U6Q+ccMNP+ageafC8j8ewF6/ngAPn/R50/4/E3XH+D6C11/gutvcP2Rrr/C9We6/g7fP9D3L/D9E33/Bt8/0vev8P0zff9O9x8c4LL+iyPA/Sd4/w3df0T3X+H9Z3T/Hd1/iPdf0v2ndP8t3X+M91/T/ed0/z0+f0DPX9DzJ/j8DT1/RM9f0fNn+PwdPX9Iz1/i86f0/C09f4zPXyfPn/8B564VyLKZT4EAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderStar);
export default __webpack_public_path__ + "static/media/slider-star.cc8048509ed79aaffe009d1f51a04e23.svg";
export { ForwardRef as ReactComponent };